import { createProfessionalExporter } from '../../../utils/professionalExport';

const headers = ['Name', 'Email', 'Gym', 'Phone', 'Joined', 'Status'];

function formatStatus(status) {
  return status.charAt(0).toUpperCase() + status.slice(1);
}

const exporter = createProfessionalExporter({
  title: 'Gym Admin List',
  headers,
  slug: 'gym-admins',
  brand: 'owner',
  getRows: (list) =>
    list.map((admin) => [
      admin.name,
      admin.email,
      admin.gym,
      admin.phone,
      admin.joinedDate,
      formatStatus(admin.status),
    ]),
  getSummary: (list) => [
    `Total admins: ${list.length}`,
    `Active: ${list.filter((a) => a.status === 'active').length}`,
  ],
});

export const printUserList = (data) => exporter.print(data);
export const exportUserCsv = (data) => exporter.csv(data);
export const exportUserExcel = (data) => exporter.excel(data);
export const exportUserPdf = (data) => exporter.pdf(data);
export const exportUsers = (data) => exporter.export(data);
